import React, { PropsWithChildren } from 'react'

import { StyledContainer, StyledLoadingDot } from './LoadingDotsStyled'

interface LoadingDotsProps {
  color?: string
}

const LoadingDots: React.FC<PropsWithChildren<LoadingDotsProps>> = ({ color }) => (
  <StyledContainer $color={color}>
    <StyledLoadingDot />
    <StyledLoadingDot />
    <StyledLoadingDot />
  </StyledContainer>
)

export default LoadingDots
